module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/id_okinawa-c6cfd2114ad71e6081c914a0fa252ccf.jpg";